/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StornextLicense
 */
export interface StornextLicense {
    /**
     * 
     * @type {string}
     * @memberof StornextLicense
     */
    license: string;
}

export function StornextLicenseFromJSON(json: any): StornextLicense {
    return StornextLicenseFromJSONTyped(json, false);
}

export function StornextLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StornextLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'license': json['license'],
    };
}

export function StornextLicenseToJSON(value?: StornextLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'license': value.license,
    };
}


